
<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    chartdata: Array,
    chartdata2: Array,
    options: Array,
  },
  mounted() {
    this.renderChart(
      {
        labels: this.options,
        datasets: [
          {
            label: "Temperature ( °C )",
            backgroundColor: "rgba(172, 0, 252,.1)",
            data: this.chartdata,
            borderWidth: 1.5,
            borderColor: "rgba(172, 0, 252,.9)",
          },
          {
            label: "Humidity ( % )",
            data: this.chartdata2,
            backgroundColor: "rgba(20, 153, 242,.1)",
            borderWidth: 1.5,
            borderColor: "rgba(20, 153, 242,.9)",
          },
        ],
      },
      {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          position: "bottom",
          align: "start",
        },
        // scales: {
        //   yAxes: [
        //     {
        //       ticks: {

        //         max: 100,

        //       },
        //     },
        //   ],
        // },
      }
    );
  },
  computed: {
    chartData: function () {
      return this.data;
    },
  },
};
</script>

<style>
</style>